<template>
  <b-container class="container-layout" fluid>
    <b-row align-h="center" class>
      <b-col lg="10" class="mt-5">
        <fieldset class="marco">
          <legend>CREAR NUEVA CUENTA DE USUARIO</legend>
          <b-row align-h="center">
            <b-col lg="8">
              <input
                required
                placeholder="Nombre"
                class="mt-5 account-dame"
                type="text"
                v-model="form.nombre"
              />
            </b-col>
          </b-row>
          <b-row align-h="center">
            <b-col lg="8">
              <input
                required
                placeholder="Correo"
                class="mt-4 account-dame"
                type="text"
                v-model="form.correo"
              />
            </b-col>
          </b-row>
          <b-row align-h="center">
            <b-col lg="4">
              <input
                :disabled="form.rol==3 ? true : false"
                required
                placeholder="DNI"
                class="mt-4 account-dame"
                type="text"
                v-model="form.dni"
              />
            </b-col>
            <b-col lg="4">
              <select class="mt-4 account-dame" placeholder="Asignar rol" v-model="form.rol">
                <option class="select-register" value="2">Asesor</option>
                <option class="select-register" value="1">Administrador</option>
                <option class="select-register" value="3">Colegio</option>
              </select>
            </b-col>
          </b-row>
          <b-row v-if="form.rol==3" align-h="center">
            <b-col lg="8">
              <select class="mt-4 account-dame" placeholder="Asignar rol" v-model="form.colegio">
                <option
                  v-for="(items, key) in colegios"
                  :value="items.id"
                  :key="key"
                >{{ items.nombre }}</option>
              </select>
            </b-col>
          </b-row>
          <b-row align-h="center" class="mb-4 mt-4">
            <button @click="createAccount()" class="account-aceptar">CREAR CUENTA</button>
          </b-row>
        </fieldset>
      </b-col>
    </b-row>
    <b-modal content-class="modal-account" hide-footer ref="modal-account" centered size="md">
      <b-row align-h="center" class="mt-3">
        <b-col cols="12">
          <img src="@/assets/images/checkAccount.png" alt />
        </b-col>
      </b-row>
      <b-row align-h="center" class="mt-3">
        <b-col cols="12">
          <p class="key-sub">Cuenta creada exitósamente</p>
        </b-col>
      </b-row>
      <b-row align-h="center" class="mb-5">
        <button @click="finish()" class="key-aceptar">ACEPTAR</button>
      </b-row>
    </b-modal>
  </b-container>
</template>
<script>
export default {
  name: "FormKey",
  props: {
    premedios: {
      type: Array
    },
    GetAccounts: {
      type: Function
    }
  },
  data: () => ({
    key: "",
    colegios: {},
    form: {
      nombre: null,
      correo: null,
      dni: null,
      rol: null,
      colegio: null,
    },
    secciones: [],
    grados: [],
    asesores: []
  }),
  created() {
    this.$store.dispatch("getCollege").then(response => {
      this.colegios = response.data.colegio;
    });
  },
  mounted() {},
  methods: {
    finish() {
      this.$refs["modal-account"].hide();
    },
    createAccount() {
      this.$store.dispatch("postRegisterAccount", this.form).then(response => {
        if (response.data) {
          this.GetAccounts();
          this.form= {
      nombre: null,
      correo: null,
      dni: null,
      rol: null,
      colegio: null,
    },
          this.$refs["modal-account"].show();
        }
      });
    }
  },
  computed: {
    isAdmin() {
      return this.$store.getters["isAdmin"];
    },
    isDisabled() {
      if (
        this.form.desde &&
        this.form.hasta &&
        this.form.colegio &&
        this.form.seccion &&
        this.form.grado &&
        this.form.aforo
      ) {
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>